import React, { useEffect, useState } from 'react'
import ListingCard from '../components/ListingCard.js'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import Map from '../components/MapList'


const Feed = () => {
  const [fetchedListings, setFetchedListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const { category } = useParams();
  const [selectedListingLocation, setSelectedListingLocation] = useState([]);

  const fetchListings = async (url) => {
    try {
      const res = await axios.get(url);
      setFetchedListings(res.data);
      setSelectedListingLocation(res.data[0].location);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    const baseUrl = 'https://curb-it-backend-91f194a5e08f.herokuapp.com/listings';
    const url = category ? `${baseUrl}/category/${category}` : baseUrl;
    fetchListings(url);
  }, [category]);

  if (loading) {
    return <div>Loading...</div>
  }

  const listings = fetchedListings.map((listing) => (
    <ListingCard
      key={listing._id}
      icon={`fa-solid fa-${listing.category}`}
      description={listing.description}
      tags={listing.tags}
      username={listing.creator?.username || "<username-not-found>"}
      id={listing._id}
      image={listing.dataUrl}
      location={listing.location}
      isListingClaimed={listing.isClaimed}
      onClick={() => {
        setSelectedListingLocation(listing.location)
        renderMap()
       }
      }
    />
  ));
  

const renderMap = () => {
  if (selectedListingLocation) {
    return (<Map location={selectedListingLocation} />);
  } else {
    return null;
  }
};

return (
  <div className="flex flex-col h-screen">
    <div className="overflow-y-auto flex-1 flex-grow">
      <div className="overflow-y-auto mt-8">{listings}</div>
    </div>
    <div className="sm:w-full h-[50vh] mb-[90px]">
      {selectedListingLocation && <Map location={selectedListingLocation} />}
    </div>
  </div>
);
}

export default Feed